// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_card_ycMPJAuLpxehVJf02WI6 {
  background-color: #ffffff;
  margin: 8px;
  width: 350px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 15px 25px -15px rgba(0, 0, 0, 0.1);
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
}
@media screen and (max-width: 1200px) {
  .style-module_card_ycMPJAuLpxehVJf02WI6 {
    width: 500px;
  }
}

.style-module_heading_dMHR01b4qSD2umSccENr {
  font-size: 16px;
  line-height: 25.6px;
  font-weight: 700;
  margin-bottom: 4px;
}

.style-module_recordsList_Tz4wiVU6K5iCk4g3UoGT {
  display: flex;
  flex-direction: column;
}

.style-module_record_WInAn6hTVMLsSfliVvbw {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.style-module_recordValue_rFqkhbRuARwpjACkzrkB {
  font-size: 14px;
  line-height: 22.6px;
  font-weight: 700;
  min-width: 28px;
  margin-right: 4px;
}

.style-module_recordLabel_AWp9O4phFJoOA0fkC1r5 {
  font-size: 14px;
  line-height: 22.6px;
  font-weight: 400;
}

.style-module_link_wRtf0whiaIeWXvGJxai1 {
  font-size: 14px;
  line-height: 22.6px;
  font-weight: 400;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/containers/WfpManagerHome/components/SummaryStatisticsCard/style.module.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,WAAA;EAEA,YAAA;EACA,kBAAA;EACA,+EAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;AAFF;AAKE;EAdF;IAeI,YAAA;EAFF;AACF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kCAAA;EAAA,0BAAA;EACA,eAAA;AAFF","sourcesContent":[".card {\n  background-color: #ffffff;\n  margin: 8px;\n  //height: 80px;\n  width: 350px;\n  border-radius: 4px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05),\n    0 15px 25px -15px rgba(0, 0, 0, 0.1);\n  //padding: 20px;\n  padding: 20px 16px;\n  display: flex;\n  flex-direction: column;\n  // justify-content: space-between;\n\n  @media screen and (max-width: 1200px) {\n    width: 500px;\n  }\n}\n\n.heading {\n  font-size: 16px;\n  line-height: 25.6px;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.recordsList {\n  display: flex;\n  flex-direction: column;\n}\n\n.record {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n}\n\n.recordValue {\n  font-size: 14px;\n  line-height: 22.6px;\n  font-weight: 700;\n  min-width: 28px;\n  margin-right: 4px;\n}\n\n.recordLabel {\n  font-size: 14px;\n  line-height: 22.6px;\n  font-weight: 400;\n}\n\n.link {\n  font-size: 14px;\n  line-height: 22.6px;\n  font-weight: 400;\n  text-decoration: underline;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `style-module_card_ycMPJAuLpxehVJf02WI6`,
	"heading": `style-module_heading_dMHR01b4qSD2umSccENr`,
	"recordsList": `style-module_recordsList_Tz4wiVU6K5iCk4g3UoGT`,
	"record": `style-module_record_WInAn6hTVMLsSfliVvbw`,
	"recordValue": `style-module_recordValue_rFqkhbRuARwpjACkzrkB`,
	"recordLabel": `style-module_recordLabel_AWp9O4phFJoOA0fkC1r5`,
	"link": `style-module_link_wRtf0whiaIeWXvGJxai1`
};
export default ___CSS_LOADER_EXPORT___;
